import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./login.css";

export default function SignupForm() {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [recheckPassword, setRecheckPassword] = useState("");
  const [message, setMessage] = useState(false);
  const [passmessage, setPassmessage] = useState(false);
  const [disable, setDisable] = useState(true);

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();

  const reset = () => {
    ref1.current.value = "";
    ref2.current.value = "";
    ref3.current.value = "";
    ref4.current.value = "";
  };

  const matchPasswords = () => {
    const val = password === recheckPassword ? false : true;
    setPassmessage(val);
  };

  useEffect(() => {
    matchPasswords();
    // console.log("Hello World")
  }, [recheckPassword, password]);

  const regexDescription =
    "It must contain at least one digit.\n It must contain at least one lowercas and one uppercase letter.\n It must contain at least one special character.\nIt must be between 8 and 16 characters in length.";

  const handleSignUp = () => {};

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="form_container">
          <h2>Admin Panel Sign Up</h2>
          <span className="abc">
            <div>
              <label htmlFor="email">Username</label>
              <input
                ref={ref1}
                type="text"
                name="username"
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Enter your username"
                required
              />
            </div>
            <div>
              <label htmlFor="email">Email</label>
              <input
                ref={ref2}
                type="email"
                name="username"
                onChange={(e) => setUserEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div>
              {passmessage && (
                <>
                  <p
                    style={{
                      textAlign: "center",
                      color: "red",
                      padding: "10px, 10px,10px,10px",
                    }}
                  >
                    Passwords do not match
                  </p>
                </>
              )}
              <div>
                <label htmlFor="password">Password</label>
                <input
                  required
                  ref={ref3}
                  type="password"
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
              </div>
              <div>
                <label htmlFor="password">Recheck password</label>
                <input
                  required
                  ref={ref4}
                  type="password"
                  name="password"
                  onChange={(e) => setRecheckPassword(e.target.value)}
                  placeholder="Re-enter password"
                />
              </div>
            </div>
            <button onClick={handleSignUp}>Sign Up</button>
            {message && (
              <>
                <div
                  style={{
                    border: "1px solid red",
                    backgroundColor: "red",
                    borderRadius: "3px",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      color: "white",
                      padding: "10px, 10px,10px,10px",
                    }}
                  ></p>
                </div>
              </>
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
